import { createFeatureSelector, createSelector } from '@ngrx/store';
import { TableDataState } from './table-data.reducer';
import {
  selectNegotiations,
  selectNegotiationsFeature,
} from '../negotiations/negotiations.selectors';
import { NegotiationsState } from '../negotiations/negotiations.reducer';

// Feature selector for the table data state
export const selectTableDataState =
  createFeatureSelector<TableDataState>('lotTableData');

// Selector for lots
export const selectTableLots = createSelector(
  selectTableDataState,
  selectNegotiationsFeature,
  (tableState: TableDataState, negotiationsState: NegotiationsState) => ({
    ...tableState,
    negotiations: [...negotiationsState.negotiations],
  })
);

// Selector for negotiations
export const selectTableNegotiations = createSelector(
  selectTableDataState,
  (state: TableDataState) => state.negotiations
);

// Selector for selectedMarket
export const selectTableSelectedMarket = createSelector(
  selectTableDataState,
  (state) => state.selectedMarket
);

export const selectTableData = createSelector(
  selectTableDataState,
  selectNegotiationsFeature,
  (tableState: TableDataState, negotiationsState: NegotiationsState) => ({
    ...tableState,
    negotiations: negotiationsState.negotiations ?? [],
  })
);
